import api from "../../../api";
import {typedQuery} from "../../typing";

export const standardFindings = typedQuery(["tprm", "standardFindings"], async () => {
  return await api.tprm.standardFindings.list();
});
